import { render, staticRenderFns } from "./DateFormat.vue?vue&type=template&id=fc5b9e5a&scoped=true&"
import script from "./DateFormat.vue?vue&type=script&lang=js&"
export * from "./DateFormat.vue?vue&type=script&lang=js&"
import style0 from "./DateFormat.vue?vue&type=style&index=0&id=fc5b9e5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5b9e5a",
  null
  
)

export default component.exports